// extracted by mini-css-extract-plugin
export default {"super-live":"frequency-settings_super-live__Hf79t","span":"frequency-settings_span__MXLqA"};